import {enumType} from 'common/enumType';

export const ContentStructure = enumType({
   UNSPECIFIED: 'UNSPECIFIED',
   BUNDLE: 'BUNDLE',
   RESOURCE: 'RESOURCE',
   BUNDLE_PRETTY: 'BUNDLE_PRETTY',
   RESOURCE_PRETTY: 'RESOURCE_PRETTY',
});
